export default function NotFoundPage() {
  return (
    <>
      <div className="flex h-screen flex-col bg-white pb-12 pt-16">
        <main className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8">
          <div className="flex flex-shrink-0 justify-center">
            <a className="inline-flex" href="/">
              <span className="sr-only">Your Company</span>
              <img alt="" className="h-20 w-auto" src="/logo512.png" />
            </a>
          </div>
          <div className="py-10">
            <div className="text-center">
              <p className="text-4xl font-semibold text-orange-600">404</p>
              <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                Página no encontrada
              </h1>
              <p className="mt-2 text-base text-gray-500">
                Lo sentimos, el enlace que solicita no pudo ser encontrado.
              </p>
              <div className="mt-6">
                <a
                  className="text-base font-medium text-orange-600 hover:text-orange-500"
                  href="/"
                >
                  Volver al Inicio
                  <span aria-hidden="true"> &rarr;</span>
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  )
}
